import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "calling-wrapper" }
const _hoisted_2 = { class: "turn-icon-container" }
const _hoisted_3 = { class: "turn-icon-container" }
const _hoisted_4 = { class: "tag" }
const _hoisted_5 = { class: "microphone-icon-container" }
const _hoisted_6 = ["id"]
const _hoisted_7 = {
  key: 0,
  class: "user-view-text-container"
}
const _hoisted_8 = { class: "user-view-info" }
const _hoisted_9 = { class: "tag" }
const _hoisted_10 = { class: "microphone-icon-container" }

import { isFromGroup, remoteList, callType, profile, t, getVolumeByUserID } from '../store/index';
import { ref, watch, watchEffect, onMounted } from "vue";
import MicrophoneIcon from "./MicrophoneIcon.vue";
import { TUICallKitServer } from '../index';
import type { RemoteUser } from "../interface";
import { CALL_TYPE_STRING } from '../constants';
import LeftSVG from "../icons/left.vue";
import RightSVG from "../icons/right.vue";
import MicrophoneClosedSVG from '../icons/microphoneClosed.vue';
import '../style.css';


export default /*#__PURE__*/_defineComponent({
  __name: 'Calling-Group',
  setup(__props) {

const currentPage = ref<number>(1);
const currentPageRemoteList = ref<RemoteUser[]>([]);
const groupUserViewClass = ref<string>("group-user-view");
const groupCallingContainerClass = ref<string>("group-calling-container");
const userViewUserId = ref<string>("user-view-user-id");

onMounted(async () => {
  await TUICallKitServer.renderLocal();
  await TUICallKitServer.renderRemote();
});

watch(currentPageRemoteList, async () => {
  const userViewCount = currentPageRemoteList.value.length + 1;
  groupUserViewClass.value = `group-user-view group-user-view-${userViewCount}`;
  groupCallingContainerClass.value = `group-calling-container group-calling-container-${userViewCount}`;
  userViewUserId.value = `user-view-user-id user-view-user-id-${userViewCount}`;
}, { flush: 'post', deep: true });

watchEffect(async () => {
  await refreshCurrentPageRemoteList();
});

async function refreshCurrentPageRemoteList() {
  let newPageList: RemoteUser[] = [];
  for (let i = (currentPage.value - 1) * 8; i < (currentPage.value) * 8 && i < remoteList.value.length; i++) {
    newPageList.push(remoteList.value[i]);
  }
  currentPageRemoteList.value = newPageList;
  await TUICallKitServer.renderRemote();
}

function pageReduce() {
  if (currentPage.value > 1) {
    currentPage.value--;
  }
}

function pageIncrease() {
  if (currentPage.value < Math.floor((remoteList.value.length - 1) / 8 + 1)) {
    currentPage.value++;
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(remoteList).length > 8)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", {
            class: "page-turn left",
            onClick: pageReduce
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(LeftSVG)
            ])
          ]),
          _createElementVNode("div", {
            class: "page-turn right",
            onClick: pageIncrease
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(RightSVG)
            ])
          ])
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(groupCallingContainerClass.value)
    }, [
      _createElementVNode("div", {
        id: "local",
        class: _normalizeClass(groupUserViewClass.value)
      }, [
        _createElementVNode("span", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_unref(profile)?.microphone)
              ? (_openBlock(), _createBlock(MicrophoneIcon, {
                  key: 0,
                  volume: _unref(getVolumeByUserID)(_unref(profile).userID)
                }, null, 8, ["volume"]))
              : (_openBlock(), _createBlock(MicrophoneClosedSVG, { key: 1 }))
          ]),
          _createTextVNode(" " + _toDisplayString(`${_unref(profile)?.nick} ${_unref(t)('me')}`), 1)
        ])
      ], 2),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentPageRemoteList.value, (remoteUserItem) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(groupUserViewClass.value),
          id: remoteUserItem.userID,
          key: remoteUserItem.userID
        }, [
          (!remoteUserItem.isEntered || (_unref(isFromGroup) && _unref(callType) === _unref(CALL_TYPE_STRING).AUDIO))
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: _normalizeClass(userViewUserId.value)
                }, _toDisplayString(remoteUserItem?.nick), 3),
                _createElementVNode("div", _hoisted_8, _toDisplayString(remoteUserItem.isEntered ? _unref(t)('already-enter') : _unref(t)('waiting')), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (remoteUserItem?.microphone)
                ? (_openBlock(), _createBlock(MicrophoneIcon, {
                    key: 0,
                    volume: _unref(getVolumeByUserID)(remoteUserItem?.userID)
                  }, null, 8, ["volume"]))
                : (_openBlock(), _createBlock(MicrophoneClosedSVG, { key: 1 }))
            ]),
            _createTextVNode(" " + _toDisplayString(remoteUserItem?.nick), 1)
          ])
        ], 10, _hoisted_6))
      }), 128))
    ], 2)
  ]))
}
}

})